export function ProportionBar({ filled, total, fillColor = '#53DA89', emptyColor = '#e2e8f0', label }) {
  const pct = total > 0 ? Math.min(100, (filled / total) * 100) : 0;
  return (
    <div className="analytics-proportion">
      {label && <div className="analytics-proportion-label">{label}</div>}
      <div className="analytics-proportion-track">
        <div
          className="analytics-proportion-fill"
          style={{ width: `${pct}%`, backgroundColor: fillColor }}
        />
        {pct < 100 && (
          <div
            className="analytics-proportion-remainder"
            style={{ width: `${100 - pct}%`, backgroundColor: emptyColor }}
          />
        )}
      </div>
    </div>
  );
}

export function StackedProportionBar({ segments, total }) {
  const safeTotal = total > 0 ? total : 0;
  return (
    <div className="analytics-proportion">
      <div className="analytics-proportion-track analytics-proportion-track-stacked">
        {segments.map((seg) => {
          const pct = safeTotal > 0 ? (seg.value / safeTotal) * 100 : 0;
          if (pct <= 0) return null;
          return (
            <div
              key={seg.key}
              className="analytics-proportion-segment"
              style={{ width: `${pct}%`, backgroundColor: seg.color }}
              title={`${seg.label}: ${seg.value.toLocaleString()}`}
            />
          );
        })}
        {safeTotal === 0 && <div className="analytics-proportion-segment" style={{ width: '100%', backgroundColor: '#e2e8f0' }} />}
      </div>
      <div className="analytics-proportion-legend">
        {segments.map((seg) => (
          <span key={seg.key} className="analytics-proportion-legend-item">
            <span className="analytics-proportion-legend-swatch" style={{ backgroundColor: seg.color }} />
            {seg.label} ({seg.value.toLocaleString()})
          </span>
        ))}
      </div>
    </div>
  );
}
